/**
 * Select — 드롭다운 선택 필드
 *
 * options 배열을 받아 <option> 목록을 렌더링한다.
 * Input과 동일한 label / error 패턴을 사용한다.
 */

import { forwardRef, SelectHTMLAttributes } from 'react'
import { cn } from '../../lib/cn.js'
import styles from './Select.module.css'

interface SelectOption {
  value: string
  label: string
}

export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'size'> {
  /** 선택 크기. 기본값 md */
  size?: 'sm' | 'md' | 'lg'
  /** 필드 레이블 텍스트 */
  label?: string
  /** 에러 메시지 */
  error?: string
  /** 렌더링할 옵션 목록 */
  options: SelectOption[]
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { size = 'md', label, error, options, className, id, ...props },
  ref,
) {
  const selectId = id ?? (label ? `select-${Math.random().toString(36).slice(2, 9)}` : undefined)

  return (
    <div className={cn(styles.wrapper, className)}>
      {label && (
        <label className={styles.label} htmlFor={selectId}>
          {label}
        </label>
      )}
      <select
        {...props}
        ref={ref}
        id={selectId}
        className={cn(styles.select, styles[size], error && styles.selectError)}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {error && <span className={styles.errorText}>{error}</span>}
    </div>
  )
})
